// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3Wp30","footer":"ModalInfo_footer__1Ys0j"};